<template>
  <div class="pt-10">
    <div class="row">
      <div class="col-11 mt-5 pt-5 ml-2 text-left">
        <h5 class="text-danger">
            <i @click="irL()" class="fa fa-arrow-left text-success m-0 p-0" style="cursor: pointer;" aria-hidden="true"></i> <strong> LISTAR USUARIO BONO PROMOCIONAL </strong>
        </h5>
      </div>
      <!-- <div class="col-1 mt-5 pt-5 text-left">
     
      </div> -->
    </div>

    <!-- Lista de bonos -->

    <div class="row mt-4">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th scope="col" style="text-align: left">Nombre</th>
                <th scope="col" style="text-align: left">Correo</th>
                <th scope="col" style="text-align: left">Fecha redención</th>
                <th scope="col" style="text-align: left">Puntos obtenidos</th>
                <th scope="col" style="text-align: left">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in items" :key="'d' + `item-${i}`">
                <td style="text-align: left">
                  {{ item.users.name }} {{ item.users.last_name }} 
                </td>
                <td style="text-align: left">
                  {{ item.users.email }}
                </td>
                <td style="text-align: left">
                  {{ item.created_at }}
                </td>
                <td style="text-align: left">
                  <h5>
                    <span class="badge badge-pill badge-danger">
                      {{ item.codes_promotionals.points }}
                    </span>
                  </h5>
                </td>
                <td style="text-align: left">
                  <h5>
                    <span class="badge badge-pill badge-success">
                    {{ item.status.name }}
                    </span>
                  </h5>
                </td>
                <td style="text-align: left">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div
        class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-12 mt-2  "
        style="text-align: initial;"
      >
        <label class="text-p mt-2">
          Página {{ currentPage }} de {{ totalPages }}
          <b class="text-danger"> | </b> total: {{ totaItems }}
        </label>
      </div>
      <div class="col-12 col-md-9 col-lg-9 col-xl-9 col-sm-12 mt-2 ">
        <div class="float-right">
          <v-pagination
            total-visible="2"
            v-model="currentPage"
            :page-count="totalPages"
            :classes="bootstrapPaginationClasses"
          ></v-pagination>
        </div>
      </div>
    </div>

    <!-- fin de la lista de bonos -->
  </div>
</template>

<script>
// import $ from "jquery";
import vPagination from "vue-plain-pagination";
import axios from 'axios';

export default {
  components: { vPagination },
  data() {
    return {
      items: [],
      paginate: ["items"],
      page: 1,
      totalPages: 1,
      totaItems: null,
      currentPage: 1,
      bootstrapPaginationClasses: {
        ul: "pagination",
        li: "page-item",
        liActive: "active",
        liDisable: "disabled",
        button: "page-link",
      },
      loading: {
        history: false,
      },
    };
  },
  methods: {
    irL(){
      this.$router.push({name: "listPromo"})
    },
    getList() {
      this.loading.history = true;
      var id = this.$route.params.id;
      axios
        .get("admin/promotional/code/users/"+id)
        .then((res) => {
          this.loading.history = false;
          if (res.data.cod == 0) {
            this.items = res.data.data;
          }
        })
        .catch((error) => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style>
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.page-link {
  border-radius: 100px;
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #dc3545;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.page-link:hover {
  color: #000;
}
</style>
